// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscribe_div_section {
  width: 51%;
}

.padding_top_none {
  padding-top: 0 !important;
}

.subscribe_top_img {
  height: 95%;
  width: 40%;
}

@media screen and (min-width: 2200px) {
  .subscribe_top_img {
    top: 0.4rem !important;
    left: 56rem !important;
    /* height: 15rem !important; */
  }
}

@media screen and (max-width: 1440px) {
  .subscribe_top_img {
    /* top: 2.4rem !important; */
    left: 40rem !important;
    /* height: 15rem !important; */
  }

  .subscribe_div_section {
    top: 26px !important;
    width: 60%;
  }

  .subscribe_bg {
    height: 20rem;
    ;
  }
}

@media screen and (max-width: 1366px) {
  .footer_last_line {
    font-size: 0.8rem;
  }
}

/* On screens that are 1024px wide or less, the background color is blue */
@media screen and (max-width: 1024px) {
  .subscribe_div_section {
    top: 2.4rem !important;
  }

  .subscribe_top_img {
    top: 0.33rem !important;
    left: 35rem !important;
    height: 93.5% !important;
  }

  .subscribe_bg {
    height: 15rem;
  }

  .form-subscribe {
    max-width: 400px;
  }
}

/* On screens that are 768px wide or less, the background color is olive */
@media screen and (max-width: 768px) {
  .subscribe_div_section {
    top: 15px !important;
  }

  .subscribe_subtext {
    max-width: 15rem;
    font-size: small !important;
    /* top: -105px !important; */

  }

  .subscribe_top_img {
    top: 0.335rem !important;
    left: 27rem !important;
    height: 93.5% !important;
  }

  .form-subscribe {
    max-width: 250px;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 480px) {
  .subscribe_div_section {
    top: 20px !important;
    width: 85%;
  }

  .subscribe_top_img {
    top: 9.6rem !important;
    left: 13rem !important;
    height: 5rem !important;
  }

  .subscribe_email_field {
    max-width: 14rem;
    left: -2px;
  }

  .subscribe_field {
    top: 4px !important;
    left: 0px;
  }

}

@media screen and (max-width: 375px) {
  .subscribe_div_section {
    top: 30px !important;
    left: 1.8rem;
  }

  .subscribe_top_img {
    top: 9.6rem !important;
    left: 10rem !important;
    height: 4rem !important;
  }

  .subscribe_email_field {
    max-width: 14rem;
    left: -2px;
  }

  .subscribe_field {
    top: 4px !important;
    left: 0px;
  }

}

.ln_higt {
  line-height: 1rem;
}

.login-cross {
  top: 0;
  position: relative;
  left: 90%;
}

.footer_bottom_fix {
  bottom: 0%;
  position: absolute;
  width: inherit;
}


/* ......... */
.eywshowhide {
  top: 20px !important;
  right: 12px !important;
}

.eywshowhide .passwordshoingbtn {
  border: none;
  color: black;
  fill: black;
  background: none;
}

.changepass .eywshowhide{
  top: 51 px !important;
  right: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/Css/footer.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,aAAa;;EAEf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;;EAE9B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;AAEF;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;AAEF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;;AAGA,cAAc;AACd;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".subscribe_div_section {\n  width: 51%;\n}\n\n.padding_top_none {\n  padding-top: 0 !important;\n}\n\n.subscribe_top_img {\n  height: 95%;\n  width: 40%;\n}\n\n@media screen and (min-width: 2200px) {\n  .subscribe_top_img {\n    top: 0.4rem !important;\n    left: 56rem !important;\n    /* height: 15rem !important; */\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .subscribe_top_img {\n    /* top: 2.4rem !important; */\n    left: 40rem !important;\n    /* height: 15rem !important; */\n  }\n\n  .subscribe_div_section {\n    top: 26px !important;\n    width: 60%;\n  }\n\n  .subscribe_bg {\n    height: 20rem;\n    ;\n  }\n}\n\n@media screen and (max-width: 1366px) {\n  .footer_last_line {\n    font-size: 0.8rem;\n  }\n}\n\n/* On screens that are 1024px wide or less, the background color is blue */\n@media screen and (max-width: 1024px) {\n  .subscribe_div_section {\n    top: 2.4rem !important;\n  }\n\n  .subscribe_top_img {\n    top: 0.33rem !important;\n    left: 35rem !important;\n    height: 93.5% !important;\n  }\n\n  .subscribe_bg {\n    height: 15rem;\n  }\n\n  .form-subscribe {\n    max-width: 400px;\n  }\n}\n\n/* On screens that are 768px wide or less, the background color is olive */\n@media screen and (max-width: 768px) {\n  .subscribe_div_section {\n    top: 15px !important;\n  }\n\n  .subscribe_subtext {\n    max-width: 15rem;\n    font-size: small !important;\n    /* top: -105px !important; */\n\n  }\n\n  .subscribe_top_img {\n    top: 0.335rem !important;\n    left: 27rem !important;\n    height: 93.5% !important;\n  }\n\n  .form-subscribe {\n    max-width: 250px;\n  }\n}\n\n/* On screens that are 600px wide or less, the background color is olive */\n@media screen and (max-width: 480px) {\n  .subscribe_div_section {\n    top: 20px !important;\n    width: 85%;\n  }\n\n  .subscribe_top_img {\n    top: 9.6rem !important;\n    left: 13rem !important;\n    height: 5rem !important;\n  }\n\n  .subscribe_email_field {\n    max-width: 14rem;\n    left: -2px;\n  }\n\n  .subscribe_field {\n    top: 4px !important;\n    left: 0px;\n  }\n\n}\n\n@media screen and (max-width: 375px) {\n  .subscribe_div_section {\n    top: 30px !important;\n    left: 1.8rem;\n  }\n\n  .subscribe_top_img {\n    top: 9.6rem !important;\n    left: 10rem !important;\n    height: 4rem !important;\n  }\n\n  .subscribe_email_field {\n    max-width: 14rem;\n    left: -2px;\n  }\n\n  .subscribe_field {\n    top: 4px !important;\n    left: 0px;\n  }\n\n}\n\n.ln_higt {\n  line-height: 1rem;\n}\n\n.login-cross {\n  top: 0;\n  position: relative;\n  left: 90%;\n}\n\n.footer_bottom_fix {\n  bottom: 0%;\n  position: absolute;\n  width: inherit;\n}\n\n\n/* ......... */\n.eywshowhide {\n  top: 20px !important;\n  right: 12px !important;\n}\n\n.eywshowhide .passwordshoingbtn {\n  border: none;\n  color: black;\n  fill: black;\n  background: none;\n}\n\n.changepass .eywshowhide{\n  top: 51 px !important;\n  right: 12px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
